import React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { getRoutesColumns } from './utils/routesColumns';
import { RouteWithDetailedView } from './types';
import { dataGridSx } from '../common/styled/DataGrid';
import pallet from '../../layouts/pallet';
import { Box } from '@mui/material';
import CustomDataGridToolbar from '../common/components/CustomDataGridToolbar';

interface RoutesTableProps {
  routes: RouteWithDetailedView[];
  loading: boolean;
  onEdit: (route: RouteWithDetailedView) => void;
  onDelete: (route: RouteWithDetailedView) => void;
  onSOSAlert: (route: RouteWithDetailedView) => void;
}

const RoutesTable: React.FC<RoutesTableProps> = ({
  routes,
  loading,
  onEdit,
  onDelete,
  onSOSAlert
}) => {
  const columns = getRoutesColumns(onEdit, onDelete, onSOSAlert);

  return (
    <Box>
      <DataGrid
        rows={routes}
        columns={columns}
        pageSizeOptions={[5, 10, 25, 100]}
        disableRowSelectionOnClick
        loading={loading}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 10 }
          },
          columns: {
            columnVisibilityModel: { id: false }
          }
        }}
        showToolbar
        slots={{ toolbar: CustomDataGridToolbar }}
        slotProps={{
          toolbar: {
            printOptions: { disableToolbarButton: true },
            showQuickFilter: true
          }
        }}
        sx={{
          ...dataGridSx(pallet),
          '& .MuiDataGrid-virtualScroller': {
            overflowY: 'auto'
          }
        }}
      />
    </Box>
  );
};

export default RoutesTable;
